import type { FC, SVGProps } from "react";

const IconRestaurantDiscount: FC<SVGProps<SVGSVGElement>> = (props) => (
	<svg viewBox="0 0 20 22" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="currentColor" {...props}>
    <path d="M1 1V8C1 9.1 1.9 10 3 10H7C7.53043 10 8.03914 9.78929 8.41421 9.41421C8.78929 9.03914 9 8.53043 9 8V1" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M5 1V21" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M19 14V1C17.6739 1 16.4021 1.52678 15.4645 2.46447C14.5268 3.40215 14 4.67392 14 6V12C14 13.1 14.9 14 16 14H19ZM19 14V21" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
);

export default IconRestaurantDiscount;
